import { Model } from '@vuex-orm/core'

export default class ArticleHasFeature extends Model{
  static entity = 'articleHasFeatures'
  static fields () {
    return {
      id: this.attr(null),
      articles_id: this.attr(null),
      feature_id: this.attr(null),
      value: this.attr(null),
    }
  }
}
  